/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../packages/core/src/routes/__root'
import { Route as DashboardRouteImport } from './../packages/core/src/routes/dashboard'
import { Route as BookmarksRouteImport } from './../packages/core/src/routes/bookmarks'
import { Route as IndexRouteImport } from './../packages/core/src/routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as BookmarksIdRouteImport } from './../packages/core/src/routes/bookmarks/$id'

const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const BookmarksIdRoute = BookmarksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BookmarksRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard/': typeof DashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard': typeof DashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard/': typeof DashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bookmarks'
    | '/dashboard'
    | '/bookmarks/$id'
    | '/dashboard/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/bookmarks' | '/bookmarks/$id' | '/dashboard'
  id:
    | '__root__'
    | '/'
    | '/bookmarks'
    | '/dashboard'
    | '/bookmarks/$id'
    | '/dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BookmarksRoute: typeof BookmarksRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/bookmarks/$id': {
      id: '/bookmarks/$id'
      path: '/$id'
      fullPath: '/bookmarks/$id'
      preLoaderRoute: typeof BookmarksIdRouteImport
      parentRoute: typeof BookmarksRoute
    }
  }
}

interface BookmarksRouteChildren {
  BookmarksIdRoute: typeof BookmarksIdRoute
}

const BookmarksRouteChildren: BookmarksRouteChildren = {
  BookmarksIdRoute: BookmarksIdRoute,
}

const BookmarksRouteWithChildren = BookmarksRoute._addFileChildren(
  BookmarksRouteChildren,
)

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BookmarksRoute: BookmarksRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
